import { TopologySubscription } from '../../../../../services/eventingApi';
import DeliveryIssueBadge from '../shared/DeliveryIssueBadge';

const SubscriptionConfig = ({ subscription }: { subscription: TopologySubscription }) => (
  <div className="flex min-w-0 flex-col rounded-md border border-gray-200 p-3 text-xs dark:border-gray-700 dark:text-gray-100">
    <div className="mb-2 flex flex-wrap gap-x-4 gap-y-1">
      <span className="font-mono font-semibold">{subscription.consumer}</span>
      <span>{subscription.protocol}</span>
      <span>raw delivery: {subscription.rawMessageDelivery ? 'sim' : 'não'}</span>
      <span className="break-all font-mono text-gray-500 dark:text-gray-400">{subscription.endpoint}</span>
      <DeliveryIssueBadge subscription={subscription} />
    </div>
    <pre className="max-h-48 flex-1 overflow-auto rounded bg-gray-900 p-2 text-green-200">
      {subscription.filterPolicy ? JSON.stringify(subscription.filterPolicy, null, 2) : 'sem filter policy (recebe tudo)'}
    </pre>
  </div>
);

export default SubscriptionConfig;
